import * as _ from "lodash";
import { computed } from "mobx";
import { AnalyticsSeriesEnum } from "app/backend/mediaAnalyticsApi";

export class HistogramPoint {
  constructor(public x: number, public y: number) {}
}

export class ChartHistogramSeries {
  constructor(public series: AnalyticsSeriesEnum, private histogramPoints: Map<number, HistogramPoint>) {}

  getByDate(date: number): HistogramPoint | undefined {
    return this.histogramPoints.get(date);
  }

  @computed
  get getAll() {
    return Array.from(this.histogramPoints.values());
  }

  @computed
  get peakValue(): HistogramPoint | undefined {
    return _.maxBy(this.getAll, point => point.y);
  }

  @computed
  get average(): number {
    return _.meanBy(this.getAll, point => point.y);
  }

  @computed
  get total(): number {
    return _.sumBy(this.getAll, point => point.y);
  }
}



// WEBPACK FOOTER //
// ./app/models/chartHistogram/chartHistogram.ts